import { isArray } from "lodash";

export const createSelectors = (name, propNames) =>
  propNames.map((propName) => (state) => {
    return state.getIn([name, ...(isArray(propName) ? propName : [propName])]);
  });
